import React from 'react'
import isPropValid from '@emotion/is-prop-valid';
import { StyleSheetManager } from 'styled-components';

interface IProps {
    isLoading: boolean;
    children: React.ReactNode;
}

export const ContentDataTable: React.FC<IProps> = ({
    isLoading,
    children }) => {
    return (
        <StyleSheetManager shouldForwardProp={isPropValid}>
        <div
            style={{
                border: '1px solid #DCDEDE',
                borderRadius: '8px',
                position: 'relative'
            }}
        >
            {children}

            {isLoading && (
                <div
                    style={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: '100%',
                        background: 'rgba(255, 255, 255, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1
                    }}
                >
                    <div className="spinner-border text-primary" role="status">
                        {/* <span className="sr-only text-black">Loading...</span> */}
                    </div>
                    <span className="text-primary fs-5 mx-2">Loading...</span>
                </div>
            )}
        </div>
        </StyleSheetManager>
    )
}
